<template>
  <div class="adm-form" v-if="actionTournamentAddSportsman == true">
    <div class="adm-form-head">
      <div>
        <span class="adm-form-kicker"><tkd-icon name="dobok"/> Спортсмен</span>
        <h4 class="adm-form-title">{{ formAddSportsman.id ? (formAddSportsman.name || 'Редагування') : 'Новий учасник' }}</h4>
      </div>
      <button type="button" class="adm-form-close" @click="saveSportsmanClose()" title="Закрити" aria-label="Закрити"><tkd-icon name="close"/></button>
    </div>

    <div class="adm-form-body">
      <section class="adm-section">
        <h5 class="adm-section-title"><tkd-icon name="user"/> Учасник</h5>
        <div class="adm-form-grid">
          <div class="adm-field adm-span-2" :class="{ 'has-error': errors.name }">
            <label class="adm-label" for="sp-name">Прізвище Ім'я По-батькові <span class="adm-req">*</span></label>
            <input id="sp-name" class="adm-input" type="text" v-model="formAddSportsman.name" placeholder="Петренко Іван Олегович" @input="clearError('name')">
            <div class="adm-field-error" v-if="errors.name">{{ errors.name }}</div>
          </div>

          <div class="adm-field adm-span-2">
            <label class="adm-label">Стать</label>
            <div class="adm-choice" role="radiogroup" aria-label="Стать">
              <button
                v-for="option in sexOptions"
                :key="option.id"
                type="button"
                role="radio"
                :aria-checked="isChosen(formAddSportsman.sex, option.id) ? 'true' : 'false'"
                :class="{ active: isChosen(formAddSportsman.sex, option.id) }"
                @click="formAddSportsman.sex = option"
              >{{ option.name }}</button>
            </div>
          </div>

          <div class="adm-field">
            <label class="adm-label" for="sp-bdate">Рік народження</label>
            <input id="sp-bdate" class="adm-input" type="number" min="1970" v-model="formAddSportsman.bdate" placeholder="2014">
          </div>

          <div class="adm-field">
            <label class="adm-label" for="sp-qualification">Кваліфікація</label>
            <input id="sp-qualification" class="adm-input" type="text" v-model="formAddSportsman.qualification" list="sp-qualification-list" placeholder="3й юнацький / 9 куп">
            <datalist id="sp-qualification-list">
              <option v-for="value in suggestions.qualification" :key="value" :value="value"></option>
            </datalist>
          </div>

          <div class="adm-field adm-span-2" :class="{ 'has-error': errors.oblast }">
            <label class="adm-label">Область <span class="adm-req">*</span></label>
            <v-select append-to-body label="name" :filterable="true" :options="regions"
                      placeholder="Оберіть область"
                      v-model="formAddSportsman.oblast" :calculate-position="positionDropdown" @input="clearError('oblast')">
              <template slot="no-options">Область не знайдено</template>
            </v-select>
            <div class="adm-field-error" v-if="errors.oblast">{{ errors.oblast }}</div>
          </div>
        </div>
      </section>

      <section class="adm-section">
        <h5 class="adm-section-title"><tkd-icon name="club"/> Клуб і тренери</h5>
        <div class="adm-form-grid">
          <div class="adm-field adm-span-2" :class="{ 'has-error': errors.organization }">
            <label class="adm-label" for="sp-organization">ФСТ / Організація <span class="adm-req">*</span></label>
            <input id="sp-organization" class="adm-input" type="text" v-model="formAddSportsman.organization" list="sp-organization-list" placeholder="Почніть вводити назву" @input="clearError('organization')">
            <datalist id="sp-organization-list">
              <option v-for="value in suggestions.organization" :key="value" :value="value"></option>
            </datalist>
            <div class="adm-field-error" v-if="errors.organization">{{ errors.organization }}</div>
          </div>

          <div class="adm-field" :class="{ 'has-error': errors.coach }">
            <label class="adm-label" for="sp-coach">Тренер <span class="adm-req">*</span></label>
            <input id="sp-coach" class="adm-input" type="text" v-model="formAddSportsman.coach" list="sp-coach-list" @input="clearError('coach')">
            <div class="adm-field-error" v-if="errors.coach">{{ errors.coach }}</div>
          </div>

          <div class="adm-field">
            <label class="adm-label" for="sp-trainer2">Тренер 2</label>
            <input id="sp-trainer2" class="adm-input" type="text" v-model="formAddSportsman.trainer2" list="sp-coach-list">
          </div>
          <datalist id="sp-coach-list">
            <option v-for="value in suggestions.coach" :key="value" :value="value"></option>
          </datalist>
        </div>
      </section>

      <section class="adm-section">
        <h5 class="adm-section-title"><tkd-icon name="belt"/> Категорія</h5>
        <div class="adm-form-grid">
          <div class="adm-field adm-span-all" :class="{ 'has-error': errors.category_id }">
            <label class="adm-label">Категорія <span class="adm-req">*</span></label>
            <v-select append-to-body label="fullname" :filter="fuseSearch" :filterable="true" :options="protocols"
                      placeholder="Пошук категорії за назвою"
                      v-model="formAddSportsman.category_id" :calculate-position="positionDropdown" @input="clearError('category_id')">
              <template slot="no-options">Категорію не знайдено</template>
              <template slot="option" slot-scope="option">
                <div class="adm-option">
                  <span class="adm-option-name">{{ option.fullname }}</span>
                  <span class="adm-chip" v-if="option.count_sportsmans != undefined">{{ option.count_sportsmans }} уч.</span>
                </div>
              </template>
              <template slot="selected-option" slot-scope="option">
                <span class="adm-option-name">{{ option.fullname }}</span>
              </template>
            </v-select>
            <div class="adm-field-error" v-if="errors.category_id">{{ errors.category_id }}</div>
          </div>
        </div>
      </section>
    </div>

    <div class="adm-form-foot">
      <span class="adm-form-summary" v-if="errorCount">Заповніть обовʼязкові поля ({{ errorCount }})</span>
      <div class="adm-form-foot-actions">
        <button type="button" class="adm-btn" @click="saveSportsmanClose()">Скасувати</button>
        <button type="button" class="adm-btn adm-btn-primary" @click="saveSportsmanAndAdd()"><tkd-icon name="save"/> Зберегти</button>
      </div>
    </div>
  </div>
</template>

<script>
import 'src/assets/css/tkd-theme.css';
import 'src/assets/css/tkd-admin.css';
import {regions} from 'src/utils/dictionary.js';

const SEX_OPTIONS = [{id:0, name:'-'}, {id:1, name:'чоловік'}, {id:2, name:'жінка'}];

export default {
  props: ['formAddSportsman'],
  name: "form-sportsman",
  data: function () {

    return {
      regions: [],
      sexOptions: SEX_OPTIONS,
      errors: {},
      // formAddSportsman:{
      //   id:'',
      //   tournament:'',
      //   name:'',
      //   bdate:'',
      //   organization:'',
      //   qualification:'',
      //   sex:'',
      //   weight:'',
      //   coach:'',
      //   trainer2:'',
      //   category_id:'',
      //   oblast:'',
      // },
    }
  },
  beforeMount() {
    this.regions = regions;
  },
  computed: {

    tournamentOne() {
      return this.$store.getters['tournament/tournamentOne'];
    },
    actionTournamentAddSportsman() {
      return this.$store.getters['settings/actionTournamentAddSportsman'];
    },
    protocols() {
      let item = this.tournamentOne.data && this.tournamentOne.data.item;
      return item && item.protocols ? item.protocols : [];
    },
    // підказки для полів з уже введених у турнір значень
    suggestions() {
      let item = this.tournamentOne.data && this.tournamentOne.data.item;
      let sportsmans = item && item.sportsmans ? item.sportsmans : [];
      let unique = key => [...new Set(sportsmans.map(sportsman => sportsman[key]).filter(Boolean))].sort();
      return {
        organization: unique('organization'),
        qualification: unique('qualification'),
        coach: [...new Set(unique('coach').concat(unique('trainer2')))].sort(),
      };
    },
    errorCount() {
      return Object.keys(this.errors).length;
    },
  },
  watch: {
    // нове відкриття форми — скидаємо помилки
    'formAddSportsman.id'() {
      this.errors = {};
    },
    actionTournamentAddSportsman() {
      this.errors = {};
    },
  },
  methods: {
    positionDropdown(dropdown, component, coordinates) {
      const toggle = component.$refs.toggle.getBoundingClientRect();
      const margin = 8;
      const maxMenuHeight = 300;
      const contentHeight = dropdown.scrollHeight || maxMenuHeight;
      const spaceBelow = Math.max(0, window.innerHeight - toggle.bottom - margin);
      const spaceAbove = Math.max(0, toggle.top - margin);
      const openAbove = spaceBelow < Math.min(contentHeight, maxMenuHeight) && spaceAbove > spaceBelow;
      const availableSpace = openAbove ? spaceAbove : spaceBelow;
      const maxHeight = Math.min(contentHeight, maxMenuHeight, availableSpace);

      dropdown.style.top = openAbove
        ? `${window.scrollY + toggle.top - maxHeight}px`
        : coordinates.top;
      dropdown.style.left = coordinates.left;
      dropdown.style.width = coordinates.width;
      dropdown.style.maxHeight = `${maxHeight}px`;
      dropdown.style.overflowY = 'auto';
    },
    fuseSearch(options, search) {
      let query = search.toLowerCase();
      return options.filter(function (el) { return (el.fullname || '').toLowerCase().includes(query)})
    },
    // значення може бути об'єктом {id, name} з форми або сирим id з сервера
    isChosen(value, id) {
      if (value === '' || value === null || value === undefined) return false;
      return value.id !== undefined ? value.id == id : value == id;
    },
    clearError(field) {
      if (this.errors[field]) {
        this.$delete(this.errors, field);
      }
    },
    saveSportsmanAndAdd() {
      this.saveSportsman(false);
      // this.formAddSportsman.id = '';
      // this.formAddSportsman.name = '';
      // this.formAddSportsman.bdate = '';
      // this.formAddSportsman.category_id = '';
    },

    saveSportsman(close) {
      var params = Object.assign({}, this.formAddSportsman);
      params.tournament = this.tournamentOne.data.item.id;
      params.sex = params.sex.id;
      params.bdate = params.bdate;
      params.organization = params.organization;
      params.qualification = params.qualification;
      params.coach = params.coach;
      params.trainer2 = params.trainer2;
      params.category_id = params.category_id.id;


      if (params.oblast != '' && params.oblast != undefined && params.oblast.name == undefined) {
        params.oblast = params.oblast;
      } else {
        params.oblast = params.oblast == '' || params.oblast == undefined ? '' : params.oblast.name;
      }

      params.id = this.formAddSportsman.id;

      // ті самі перевірки, що й раніше, але з підсвіткою полів замість alert
      let errors = {};
      if ((params.name || '').length < 1) {
        errors.name = 'Вкажіть ПІБ учасника';
      }
      if (parseInt(params.category_id) < 1) {
        errors.category_id = 'Оберіть категорію';
      }
      if ((params.oblast || '').length < 1) {
        errors.oblast = 'Оберіть область';
      }
      if ((params.coach || '').length < 1) {
        errors.coach = 'Вкажіть тренера';
      }
      if ((params.organization || '').length < 1) {
        errors.organization = 'Вкажіть організацію';
      }
      this.errors = errors;
      if (Object.keys(errors).length) {
        return false;
      }

      if (params.id != undefined) {
        this.$store.dispatch('tournament/addSportsman', params)
            .then(() => this.updatedData())
            .catch(error => {
              this.$notify({ text: 'Помилка збереження', type: 'error' });
            });

        // TODO добавить обработку ошибок

      } else {

        // .then(() => this.successfulSaved())
        // .catch(error => {
        //   this.faileSaved()
        // });
      }

      this.$store.dispatch('tournament/fetchTournamentOneFull', {id: this.tournamentOne.data.item.id});
      this.$modal.hide('sportsman-form-modal');


    },

    saveSportsmanClose() {
      this.$store.dispatch('settings/setActionTournamentAddSportsman', false);
      this.$modal.hide('sportsman-form-modal');
    },

    /**
     * Оновлення данних по турніру
     */
    updatedData() {
      this.$store.dispatch('tournament/fetchTournamentOneFull', {id: this.tournamentOne.data.item.id});
      this.$notify(
          {
            text: 'Дані оновлено',
            horizontalAlign: 'right',
            verticalAlign: 'top',
            duration: 10000,
            speed: 1000,
            type: 'success'
          })
    },

  },
}
</script>

<style scoped>
  /* поле пошуку v-select без рамки lbd */
  .adm-field >>> .vs__search { border: 0; }
</style>
